// the enum contains label text colors for two types of pin on google map
export enum LabelTextColor {
    // due pin (yellow) have text in grey color
    DuePinLabelColor = "#414141",
    // overdue pin (red) / clicked pin (blue) have text in white color
    OverDueLabelColor = "#FFFFFF"
}
